import { render } from "./supportIcon.vue?vue&type=template&id=68df5f0f&scoped=true"
import script from "./supportIcon.vue?vue&type=script&lang=js"
export * from "./supportIcon.vue?vue&type=script&lang=js"

import "./supportIcon.vue?vue&type=style&index=0&id=68df5f0f&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-68df5f0f"]])

export default __exports__